import styled, { css, createGlobalStyle } from 'styled-components';

import variables from '../../../styles/variables';
import Link from '../Link/Link';
import Image from "../Image/Image";

const bladePadding = 15;
const bladePaddingMobile = 30;

export const PageScrollStyles = createGlobalStyle`
  html.js-blade-open {
    touch-action: none;
    -webkit-overflow-scrolling: none;
    overflow: hidden;
    overscroll-behavior: none;
  }
`;

// Dark overlay under blade
export const Overlay = styled.div`
  position: fixed;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: rgba(0, 0, 0, 0);
  transition:
    visibility 700ms,
    background-color 600ms linear;
  z-index: 10000;
`;

// Main blade component
export const OuterBladeContainer = styled.div`
  height: 100%;
  width: 100%;
  min-width: 320px;
  position: fixed;
  top: 0;
  right: 0;
  overflow: auto;
  z-index: 99998;
  background-color: ${variables.colorWhite};
  box-shadow: 0 7px 12px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 15px ${bladePadding}px 70px;
  transform: translateX(110%);
  transition: transform 700ms;

  @media only screen and (min-width: ${(props) => props.bladeWidth}px) {
    max-width: ${(props) => props.bladeWidth}px;
    padding: 30px ${bladePaddingMobile}px 70px;
  }

  ${({ noPadding }) => noPadding
    && css`
      @media only screen and (min-width: ${(props) => props.bladeWidth}px) {
        padding: 0;
      }

      @media screen and (max-width: ${(props) => props.bladeWidth}px) {
        padding: 0;
      }
    `}

  &.on-blade-enter-done {
    transform: translateX(0);

    ~ ${Overlay} {
      background-color: rgba(0, 0, 0, 0.3);
    }
  }
  &.on-blade-exit {
    ~ ${Overlay} {
      background-color: rgba(0, 0, 0, 0);
    }
  }
  @media screen and (max-width: ${(props) => props.bladeWidth}px) {
    width: 100%;
    align-items: flex-start;
  }
`;

export const BladeContent = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  margin: 0 auto;

  hr.closeHR {
    background-color: #787878;
    @media screen and (max-width: ${(props) => props.bladeWidth}px) {
      display: none;
    }
  }

  &::after {
    display: table;
    clear: both;
    content: '';
  }

  .focus-lock {
    height: 100%;
  }
`;

// Top section with button and logo
export const Legend = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 100%;
  width: 100%;
  align-items: center;
  padding-left: 30px;
  margin: 0 auto;
  @media screen and (max-width: ${(props) => props.bladeWidth}px) {
    padding-left: 1.25rem;
  }
  @media screen and (max-width: ${(props) => props.bladeWidth}px) {
    grid-template-columns: 25% 50% 25%;
    grid-template-rows: 2;
    grid-template-areas:
      'back logo close'
      'empty empty empty';
    padding-left: 0;
    margin-bottom: 50px;
  }
  @media screen and (max-width: 475px) {
    grid-template-areas:
      'empty logo close'
      'back empty empty';
  }
`;

export const LogoContainer = styled.div`
  display: none;
  @media screen and (max-width: ${(props) => props.bladeWidth}px) {
    display: flex;
    flex-shrink: 0;
    width: 100%;
    grid-area: logo;
    justify-content: center;
  }
`;

export const StyledImage = styled(Image)`
  margin: 0;
`;

export const NavLink = styled(Link)`
  margin: 0;
  text-decoration: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1.14px;
  max-width: 175px;
  &:hover {
    text-decoration: underline;
  }
  img {
    margin: 0;
    width: 100%;
  }
`;

export const CloseBtn = styled.button`
  background: none;
  padding: 10px 0;
  border: none;
  height: 40px;
  font-size: 0.8rem;
  font-weight: 600;
  justify-self: end;
  grid-column-start: 2;
  cursor: pointer;
  letter-spacing: 0.85px;
  @media screen and (max-width: ${(props) => props.bladeWidth}px) {
    span#closeText {
      display: none;
    }
    grid-area: close;
  }
`;

export const CloseIcon = styled.span`
  width: 17px;
  height: 17px;
  position: relative;
  margin-left: 10px;
  float: right;
  .bm-cross-left {
    position: absolute;
    width: 2px;
    height: 15px;
    transform: rotate(45deg);
    background: rgb(51, 51, 51);
  }
  .bm-cross-right {
    position: absolute;
    width: 2px;
    height: 15px;
    transform: rotate(-45deg);
    background: rgb(51, 51, 51);
  }
`;
